import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import formatDate from '../../utils/dateFormatter';
import { isMobile, openInApp } from '../../utils/openInApp';
import { FormattedMessage } from 'react-intl';
import Carousel from 'react-multi-carousel';

const responsive = {
    desktop: {
        breakpoint: { max: 5000, min: 0 },
        items: 1,
        slidesToSlide: 1
    }
}

function AdvertisementPage({ language }) {

    const { advertisementId } = useParams();
    const carouselRef = useRef(null);
    const galleryVideoRefs = useRef({});
    const [advertisement, setAdvertisement] = useState(null);
    const [notFound, setNotFound] = useState(false);
    const [selectedAdvertisementContent, setSelectedAdvertisementContent] = useState(null);
    const [advertisementContents, setAdvertisementContents] = useState([]);
    const advertisementContentDialogRef = useRef(null);
    const [galleryTargetIndex, setGalleryTargetIndex] = useState(0);
    const [isCarouselVisible, setIsCarouselVisible] = useState(false);
    const [transitionMs, setTransitionMs] = useState(0);

    const handleOpenAdvertisementContentDialog = () => {
        if (advertisementContentDialogRef.current) {
            advertisementContentDialogRef.current.showModal();
        }
    };

    // The #t=0.2 media fragment only exists to force a visible frame when the content has
    // no poster image. On a playable video it would also make playback start 0.2s in, so
    // it is dropped whenever a thumbnail is available to act as the poster instead.
    const playableVideoSrc = (content) =>
        content.thumbnail_link ? content.content_link : content.content_link + "#t=0.2";

    // The carousel keeps every slide mounted, so a video left playing keeps its audio
    // running after the user swipes away. Pause everything except the visible slide.
    const pauseInactiveGalleryVideos = (currentSlide) => {
        Object.entries(galleryVideoRefs.current).forEach(([index, video]) => {
            if (video && Number(index) !== currentSlide) {
                video.pause();
            }
        });
    };

    const handleCloseAdvertisementContentDialog = () => {
        if (advertisementContentDialogRef.current) {
            advertisementContentDialogRef.current.close();
        }
    };

    const isXL = useMediaQuery({ query: '(min-width: 1824px)' });
    const isLG = useMediaQuery({ query: '(min-width: 1224px)' }) && !isXL;
    const isMD = useMediaQuery({ query: '(min-width: 768px)' }) && !isLG && !isXL;
    const isSM = useMediaQuery({ query: '(min-width: 425px)' }) && !isMD && !isLG && !isXL;
    const isXS = useMediaQuery({ query: '(max-width: 425px)' });

    useEffect(() => {
        const fetchAdvertisementDeatils = async () => {
            axios.get(`${process.env.REACT_APP_API_URL}advertisement/getAdvertisementWithDetails?advertisementId=${advertisementId}&language=${language}&onlyActives=1`)
                .catch((err) => {
                    console.log("err: " + err);
                    setAdvertisement(null);
                    setNotFound(true);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 200 && response.data.advertisement.user_is_deleted === 0) {
                        setAdvertisement(response.data.advertisement);
                        setSelectedAdvertisementContent(response.data.advertisement.advertisement_contents[0]);
                        document.title = response.data.advertisement.title;
                    } else {
                        setNotFound(true);
                    }
                });
        }

        fetchAdvertisementDeatils();


    }, [advertisementId, language]);

    useEffect(() => {
        if (advertisementContents.length > 0) {
            handleOpenAdvertisementContentDialog();
        } else {
            handleCloseAdvertisementContentDialog();
        }
    }, [advertisementContents]);

    useEffect(() => {
        if (advertisementContents.length === 0) return;

        setIsCarouselVisible(false);
        setTransitionMs(0); // animasyonu kapat

        let r1 = 0, r2 = 0, r3 = 0;
        r1 = requestAnimationFrame(() => {
            r2 = requestAnimationFrame(() => {
                if (carouselRef.current) {
                    carouselRef.current.goToSlide(galleryTargetIndex); // animasyonsuz atla
                }
                setIsCarouselVisible(true);  // şimdi göster
                // bir sonraki frame'de animasyonu geri aç
                r3 = requestAnimationFrame(() => setTransitionMs(300));
            });
        });

        return () => {
            if (r1) cancelAnimationFrame(r1);
            if (r2) cancelAnimationFrame(r2);
            if (r3) cancelAnimationFrame(r3);
        };
    }, [advertisementContents, galleryTargetIndex]);
    return (
        <div>
            {advertisement &&
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "45px", paddingBottom: "45px" }}>
                    {!!selectedAdvertisementContent && <div style={{ position: "relative", cursor: "pointer" }}
                        onClick={() => {
                            if (selectedAdvertisementContent.is_photo === 1) {
                                const idx = advertisement.advertisement_contents.findIndex((it) => it.id === selectedAdvertisementContent.id);
                                setGalleryTargetIndex(idx);
                                setAdvertisementContents(advertisement.advertisement_contents); // ORİJİNAL SIRA
                            }
                        }}
                    >
                        {selectedAdvertisementContent.is_photo === 1 ?
                            <img className={"rounded12"} src={selectedAdvertisementContent.content_link} alt="advertisement-lg" style={{ width: isMD ? 750 : isSM ? 350 : isXS ? 260 : 800, height: isMD ? 450 : isSM ? 250 : isXS ? 225 : 600, objectFit: "cover" }} />
                            :
                            <video
                                key={selectedAdvertisementContent.id}
                                controls
                                className={"rounded12"}
                                poster={selectedAdvertisementContent.thumbnail_link}
                                style={{ width: isMD ? 750 : isSM ? 350 : isXS ? 260 : 800, height: isMD ? 450 : isSM ? 250 : isXS ? 225 : 600, objectFit: "cover" }}>
                                <source src={playableVideoSrc(selectedAdvertisementContent)} />
                                <FormattedMessage id="video_error" />
                            </video>
                        }
                        {!!advertisement.is_truly_featured &&
                            <div
                                style={{
                                    background: "#8C52FF",
                                    position: "absolute",
                                    left: "10px",
                                    top: "10px",
                                    padding: "4px 12px"
                                }}
                                className={'rounded12'}
                            >
                                <p style={{ fontSize: "16px", margin: 0, color: "white" }}>
                                    <FormattedMessage id="urgent_ad" />
                                </p>
                            </div>
                        }
                    </div>}
                    <div style={{ display: "flex", gap: "10px", overflowX: "scroll", width: isMD ? 750 : isSM ? 350 : isXS ? 260 : 800, marginTop: "8px" }}>
                        {advertisement.advertisement_contents.map((content, index) => {
                            if (content.is_photo === 1) {
                                return <div key={content.id}
                                    onClick={() => {
                                        setSelectedAdvertisementContent(content);
                                    }}>
                                    <img
                                        className={"rounded12"}
                                        src={content.content_link}
                                        alt={`advertisement-sm-${index}`}
                                        width={isMD ? 220 : isSM ? 175 : isXS ? 130 : 260}
                                        style={{
                                            height: isMD ? 130 : isSM ? 105 : isXS ? 77 : 160,
                                            objectFit: "cover",
                                            ...(selectedAdvertisementContent?.id === content.id ? { border: "2px solid #8C52FF" } : {}),
                                            cursor: "pointer",
                                        }}
                                    />
                                </div>
                            } else {
                                return <div key={content.id}
                                    onClick={() => {
                                        setSelectedAdvertisementContent(content);
                                    }}>
                                    <video className={"rounded12"}
                                        src={content.content_link + "#t=0.2"}
                                        poster={content.thumbnail_link}
                                        preload={content.thumbnail_link ? "none" : "metadata"}
                                        style={{
                                            width: isMD ? 220 : isSM ? 175 : isXS ? 130 : 260, height: isMD ? 130 : isSM ? 105 : isXS ? 77 : 160,
                                            objectFit: "cover",
                                            ...(selectedAdvertisementContent?.id === content.id ? { border: "2px solid #8C52FF" } : {}),
                                            cursor: "pointer",
                                        }}
                                    >
                                        <FormattedMessage id="video_error" />
                                    </video></div>
                            }
                        })}
                    </div>
                    <div style={{ width: isMD ? 750 : isSM ? 350 : isXS ? 260 : 800 }}>
                        <h1 style={{ fontSize: "24px", fontWeight: 900 }}>{advertisement.title}</h1>
                        <p style={{ fontSize: "16px", whiteSpace: "pre-line", wordBreak: "break-all" }}>{advertisement.description}</p>
                        {
                            !!(advertisement.service_date) &&
                            <p>
                                <b><FormattedMessage id='service_date' />: </b>{formatDate(advertisement.service_date,
                                    {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    },
                                    true, language)}
                            </p>
                        }
                        <div
                            style={{
                                display: "flex",
                                flexDirection: isSM || isXS ? "column" : "row",
                                alignItems: isSM || isXS ? "start" : "center",
                                gap: "16px"
                            }}
                        >
                            <div style={{ display: "flex", gap: "4px", alignItems: "center" }} >
                                <img className={"rounded12"} src={advertisement.user_profile_photo_link} alt="user-profile" width={24} height={24} />
                                <p style={{ fontSize: "16px", margin: 0 }}>{advertisement.user_name} {advertisement.user_surname}</p>
                            </div>
                            <div className={'rounded12'} style={{ display: "flex", alignItems: "center", gap: "8px", background: "#F2F0F5", padding: "4px 12px" }}>
                                <img src="/assets/images/location-2.png" alt="location" width={16} height={16} />
                                <p style={{ fontSize: "16px", margin: 0 }}>{advertisement.city}, {advertisement.county}</p>
                            </div>
                        </div>
                        <div style={{ marginTop: "20px", display: "flex", flexDirection: isSM || isXS ? "column" : "row", justifyContent: "space-between", alignItems: "start", rowGap: "10px" }}>
                            <div>
                                <p style={{ fontSize: "14px", color: "#999999", margin: 0 }}><FormattedMessage id='view_count' />: {advertisement.view_count}</p>
                                <p style={{ fontSize: "14px", color: "#999999", margin: isSM || isXS ? "9px 0 0 0" : 0 }}><FormattedMessage id='last_update' />: {formatDate(advertisement.updated_date, null, true, language)}</p>
                            </div>
                            <p style={{ fontSize: "14px", color: "#999999", margin: 0 }}><FormattedMessage id='ad_number' />: {advertisement.advertisement_no}</p>
                        </div>
                        {isMobile() && (
                            <div style={{ display: "flex", justifyContent: "center", marginTop: "37px" }}>
                                <button
                                    onClick={() => openInApp("advertisement", advertisementId)}
                                    style={{
                                        background: "#8C52FF",
                                        padding: "16px 10px",
                                        width: isSM ? "50%" : isXS ? "60%" : "35%",
                                        textAlign: "center",
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                    className={'rounded16 app-button'}
                                >
                                    <p style={{ fontSize: "18px", margin: 0, color: "white", userSelect: "none" }}>
                                        <FormattedMessage id="see_in_app" />
                                    </p>
                                </button>
                            </div>
                        )}
                    </div>
                    {advertisementContents?.length > 0 &&
                        <dialog
                            ref={advertisementContentDialogRef}
                            style={{
                                border: "none",
                                borderRadius: "8px",
                                padding: "20px",
                                minWidth: isSM || isXS ? "80%" : "60.5%",
                                maxWidth: isSM || isXS ? "80%" : "60.5%",
                                maxHeight: isSM || isXS ? "50vh" : isMD ? "60vh" : "",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <p style={{ fontSize: "24px", margin: "0", fontWeight: 800 }}>
                                    <FormattedMessage id='gallery' />
                                </p>
                                <button
                                    onClick={() => {
                                        setAdvertisementContents([]);
                                    }}
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        fontSize: "16px",
                                        cursor: "pointer"
                                    }}
                                >
                                    <img src="/assets/images/close-icon.png" alt="close" height={"24px"} width={"24px"} />
                                </button>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                {advertisementContents?.length > 0 &&
                                    <div style={{ visibility: isCarouselVisible ? 'visible' : 'hidden' }}>
                                        <Carousel
                                            ref={carouselRef}
                                            responsive={responsive}
                                            containerClass='advertisement-carousel-container'
                                            itemClass='advertisement-carousel-item'
                                            dotListClass='react-multi-carousel-list'
                                            renderButtonGroupOutside
                                            arrows={!(isSM || isXS)}
                                            transitionDuration={transitionMs}                 // ← sadece ilk atlamada 0ms
                                            customTransition={`transform ${transitionMs}ms`}  // ← güvence
                                            afterChange={(_previousSlide, { currentSlide }) => pauseInactiveGalleryVideos(currentSlide)}
                                        >
                                            {advertisementContents.map((item, index) =>
                                                <div key={item.id} style={{ textAlign: "center" }}>
                                                    {item.is_photo === 1 ?
                                                        <img src={item.content_link} alt="advertisement-content"
                                                            style={{
                                                                maxWidth: "100%",
                                                                minWidth: "100%",
                                                                maxHeight: isSM || isXS ? "45vh" : isMD ? "50vh" : "75vh",
                                                                minHeight: isSM || isXS ? "45vh" : isMD ? "50vh" : "75vh",
                                                                objectFit: "contain",
                                                                userSelect: "none",
                                                            }} />
                                                        :
                                                        <video controls
                                                            ref={(el) => { galleryVideoRefs.current[index] = el; }}
                                                            poster={item.thumbnail_link}
                                                            style={{
                                                                maxWidth: "100%",
                                                                minWidth: "100%",
                                                                maxHeight: isSM || isXS ? "45vh" : isMD ? "50vh" : "75vh",
                                                                minHeight: isSM || isXS ? "45vh" : isMD ? "50vh" : "75vh",
                                                                objectFit: "contain",
                                                                userSelect: "none",
                                                            }}>
                                                            <source src={playableVideoSrc(item)} />
                                                            <FormattedMessage id="video_error" />
                                                        </video>
                                                    }
                                                </div>
                                            )}
                                        </Carousel>
                                    </div>
                                }
                            </div>
                        </dialog>
                    }
                </div>
            }
            {
                notFound &&
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "65vh" }}>
                    {/* <h1 style={{ fontSize: "100px", fontWeight: 900, margin: 0, color: "#8C52FF" }}>404</h1> */}
                    <h2 style={{ fontSize: "24px", fontWeight: 900, margin: 0 }}>
                        <FormattedMessage id="ad_not_found" />
                    </h2>
                </div>
            }
        </div>
    )
}

export default AdvertisementPage